import { useCallback, useEffect, useState } from "react";
import type { CustomFieldDefinition, EntityType } from "@/types/customFields";
import { apiFetch } from "@/utils/api";

export function useCustomFieldDefinitions(entityType: EntityType) {
  const [definitions, setDefinitions] = useState<CustomFieldDefinition[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    const data = await apiFetch<{ fields: CustomFieldDefinition[] }>(
      `/admin/custom-fields?entityType=${entityType}`,
    );
    setDefinitions(data.fields);
  }, [entityType]);

  useEffect(() => {
    setLoading(true);
    reload()
      .catch((e) => setError(e instanceof Error ? e.message : "Failed to load custom fields"))
      .finally(() => setLoading(false));
  }, [reload]);

  return { definitions, loading, error, reload };
}
